import { createUseStyles } from 'react-jss'

export default createUseStyles({
  headlineText: {
    fontWeight: 700,
    padding: 0,
    width: '100%'
  },
  skeletonHeadline: {
    margin: 0,
    marginBottom: 3
  }
})
